import { Component } from '@angular/core';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { SUREPARKSubscriber } from '../../../../../express-tRPC/src/shared/types';

@Component({
  selector: 'app-accounts-validity-update',
  templateUrl: './accounts-validity-update.component.html',
  styleUrl: './accounts-validity-update.component.scss'
})
export class AccountsValidityUpdateComponent {

  accounts: SUREPARKSubscriber[] = [];
  totalAccounts: number = 0;
  isAccountslistLoading: boolean = false;

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.getAccountsList();
  }

  getIds(identifiers: any[]): string {
    return identifiers.map((identifier: any) => identifier['identifierNumber']).join(",");
  }

  async getAccountsList() {

    this.isAccountslistLoading = true;
    let tenantsResult: any = await this.trpcService.trpc.surepark.getExpireInactiveMembers.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.isAccountslistLoading = false;
    });

    console.log(tenantsResult)
    this.accounts = tenantsResult;
    this.totalAccounts = tenantsResult?.count || 0;

    this.isAccountslistLoading = false;

  }

  async markInactiveSureparkAccounts() {
    this.isAccountslistLoading = true;
    let tenantsResult: any = await this.trpcService.trpc.surepark.expireInactiveMembers.mutate({}).then(() => {
      this.messageService.add({
        severity: "success",
        detail: "Account(s) updated successfully.",
      });
      this.getAccountsList();
    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.isAccountslistLoading = false;
    });

    console.log(tenantsResult)
    this.accounts = tenantsResult;
    this.totalAccounts = tenantsResult?.count || 0;

    this.isAccountslistLoading = false;
  }

}
